import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, createLazyComponent, type LazyComponent } from 'owa-bundling';
import { getStore } from './store/feedbackDialogStore';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FeedbackSdkApi" */ './lazyIndex'),
    { name: 'FeedbackSdkApi' }
);

// Export the manager component to be rendered at app root. Gate the lazy import on the
// dialog being open so the FeedbackSdkApi chunk only loads on demand (when showFeedbackDialog
// sets isOpen), rather than eagerly on every startup that mounts this host.
export const FeedbackDialogManager: LazyComponent<{}, unknown> = createLazyComponent(
    lazyModule,
    m => m.FeedbackDialogManager,
    undefined,
    undefined,
    { onlyImportIf: () => getStore().isOpen }
);

// Export actions to trigger the dialog
export { showFeedbackDialog } from './actions/showFeedbackDialog';

export const lazyGetFeedbackComplianceChecks: LazyImport<
    typeof lazyIndex.getFeedbackComplianceChecks,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFeedbackComplianceChecks);

export type {
    ContextDataFile,
    DiagnosticsGlobalFeatures,
    IFeedbackInitOptions,
} from './schema/FeedbackTypes';
export type { FeedbackDialogProps } from './schema/feedbackDialogProps';
